import { useMutation } from '@apollo/client'
import { useCallback } from 'react'

import {
  CreateShortLinkMutation,
  CreateShortLinkMutationVariables,
} from '@/clients/utoniq-core/schema'
import { CREATE_SHORT_LINK_QUERY } from '@/components/pages/Ulink/viewModel'
import { config } from '@/config'

type UseCreateShortLinkProps = {
  path: string
}

export const useCreateShortLink = ({ path }: UseCreateShortLinkProps) => {
  const redirectUrl = config.domain + path
  const [createShortLink] = useMutation<
    CreateShortLinkMutation,
    CreateShortLinkMutationVariables
  >(CREATE_SHORT_LINK_QUERY)

  const createLink = useCallback(async () => {
    try {
      const { data } = await createShortLink({
        variables: { redirectUrl },
      })
      return data?.createShortLink?.shortLink ?? redirectUrl
    } catch {
      return redirectUrl
    }
  }, [redirectUrl, createShortLink])

  return createLink
}
